import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import db from "./Firebase";

const AnalyticsScreen = () => {
    const [userStats, setUserStats] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [searchUserId, setSearchUserId] = useState("");

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
            let usersData = snapshot.docs.map((userDoc) => {
                let userId = userDoc.id;
                let userData = userDoc.data();

                return {
                    user_id: userId,
                    total_opens: userData.total_opens || 0,
                    last_active: userData.last_active ? formatTimestamp(userData.last_active) : "N/A",
                    is_active: userData.is_active || false,
                    is_inquisitive: userData.is_inquisitive || false,
                    page_visits: Array.isArray(userData.page_visits) ? userData.page_visits : [],
                };
            });

            setUserStats(usersData);
        });

        return () => unsubscribe();
    }, []);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "N/A";

        let date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
        return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
    };

    const toggleRow = (userId) => {
        setExpandedRows((prev) => ({ ...prev, [userId]: !prev[userId] }));
    };

    // Filter user analytics based on search query
    const filteredUsers = userStats.filter((user) =>
        user.user_id.toLowerCase().includes(searchUserId.toLowerCase())
    );

    return (
        <>
            <div className="p-2 flex justify-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="card-header pb-0 px-3 d-flex justify-content-end">

                <Link to="/dashbaordall">
                    <button className="btn btn-success btn-sm mr-3" >
                        Log Dashboard
                    </button>
                </Link>
                <Link to="/page_visit">
                    <button className="btn btn-success btn-sm" >
                        User Page Visits Logs
                    </button>
                </Link>

            </div>

            <div className="p-4 bg-white shadow-lg rounded-lg">
                <h3 className="text-2xl font-bold mb-4">User Analytics (Real-Time)</h3>

                {/* Search Bar */}
                <input
                    type="text"
                    placeholder="Search by User ID..."
                    value={searchUserId}
                    onChange={(e) => setSearchUserId(e.target.value)}
                    className="border p-2 rounded-md w-1/3 mb-4"
                />

                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200">
                        <thead className="bg-gray-100">
                            <tr className="text-left">
                                <th className="border p-3 font-semibold">User ID</th>
                                <th className="border p-3 font-semibold">Total Opens</th>
                                <th className="border p-3 font-semibold">Last Active</th>
                                <th className="border p-3 font-semibold">Active (45s+)</th>
                                <th className="border p-3 font-semibold">Inquisitive (2+ Pages)</th>
                                <th className="border p-3 font-semibold">Page Visits</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user) => (
                                    <React.Fragment key={user.user_id}>
                                        <tr className="hover:bg-gray-50">
                                            <td className="border p-3 font-medium">{user.user_id}</td>
                                            <td className="border p-3">{user.total_opens}</td>
                                            <td className="border p-3">{user.last_active}</td>
                                            <td className={`border p-3 ${user.is_active ? "text-green-600" : "text-red-600"}`}>
                                                {user.is_active ? "🟢 Yes" : "🔴 No"}
                                            </td>
                                            <td className={`border p-3 ${user.is_inquisitive ? "text-green-600" : "text-red-600"}`}>
                                                {user.is_inquisitive ? "🟢 Yes" : "🔴 No"}
                                            </td>
                                            <td className="border p-3">
                                                <button
                                                    onClick={() => toggleRow(user.user_id)}
                                                    className="text-blue-600 font-medium flex items-center"
                                                >
                                                    {expandedRows[user.user_id] ? "▼ Hide" : "▶ View Visits"}
                                                </button>
                                            </td>
                                        </tr>
                                        {expandedRows[user.user_id] && (
                                            <tr>
                                                <td colSpan={6} className="border p-3 bg-gray-50">
                                                    {user.page_visits.length > 0 ? (
                                                        <table className="w-full border-collapse border border-gray-300 mt-2">
                                                            <thead className="bg-gray-200">
                                                                <tr>
                                                                    <th className="border p-2 text-left font-semibold">Module</th>
                                                                    <th className="border p-2 text-left font-semibold">Category</th>
                                                                    <th className="border p-2 text-left font-semibold">Description</th>
                                                                    <th className="border p-2 text-left font-semibold">Visit Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {user.page_visits
                                                                    .map((visit) => ({
                                                                        ...visit,
                                                                        visit_time: visit.visit_time?.toDate
                                                                            ? visit.visit_time.toDate()
                                                                            : new Date(visit.visit_time),
                                                                    }))
                                                                    .sort((a, b) => b.visit_time.getTime() - a.visit_time.getTime())
                                                                    .map((visit, i) => (
                                                                        <tr key={i} className="hover:bg-gray-100">
                                                                            <td className="border p-2">{visit.page_name}</td>
                                                                            <td className="border p-2">{visit.category}</td>
                                                                            <td className="border p-2">{visit.description}</td>
                                                                            <td className="border p-2">{formatTimestamp(visit.visit_time)}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <span className="text-gray-500">No visits recorded</span>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center text-gray-500 p-4">
                                        No matching users found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default AnalyticsScreen;



// import React, { useState, useEffect } from "react";


// import { collection, onSnapshot } from "firebase/firestore";
// import db from "./Firebase";

// const AnalyticsScreen = () => {
//     const [userStats, setUserStats] = useState([]);
//     const [expandedRows, setExpandedRows] = useState({});

//     useEffect(() => {
//         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
//             let usersData = snapshot.docs.map((userDoc) => {
//                 let userId = userDoc.id;
//                 let userData = userDoc.data();

//                 return {
//                     user_id: userId,
//                     total_opens: userData.total_opens || 0,
//                     last_active: userData.last_active ? formatTimestamp(userData.last_active) : "N/A",
//                     is_active: userData.is_active || false,
//                     is_inquisitive: userData.is_inquisitive || false,
//                     page_visits: Array.isArray(userData.page_visits) ? userData.page_visits : [],
//                 };
//             });

//             setUserStats(usersData);
//         });

//         return () => unsubscribe();
//     }, []);

//     const formatTimestamp = (timestamp) => {
//         if (!timestamp) return "N/A";

//         let date;

//         // Firestore Timestamp object (convert using .toDate())
//         if (timestamp?.toDate) {
//             date = timestamp.toDate();
//         }
//         // If timestamp is a string or number, convert it to a Date object
//         else {
//             date = new Date(timestamp);
//         }

//         // Check if date conversion was successful
//         return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
//     };



//     const toggleRow = (userId) => {
//         setExpandedRows((prev) => ({ ...prev, [userId]: !prev[userId] }));
//     };

//     return (
//         <div className="p-2 bg-white shadow-lg rounded-lg">
//             <h3 className="text-2xl font-bold mb-4">User Analytics (Real-Time)</h3>
//             <div className="overflow-x-auto">
//                 <table className="w-full border-collapse border border-gray-200">
//                     <thead className="bg-gray-100">
//                         <tr className="text-left">
//                             <th className="border p-3 font-semibold">User ID</th>
//                             <th className="border p-3 font-semibold">Total Opens</th>
//                             <th className="border p-3 font-semibold">Last Active</th>
//                             <th className="border p-3 font-semibold">Active (45s+)</th>
//                             <th className="border p-3 font-semibold">Inquisitive (2+ Pages)</th>
//                             <th className="border p-3 font-semibold">Page Visits</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {userStats.map((user) => (
//                             <React.Fragment key={user.user_id}>
//                                 <tr className="hover:bg-gray-50">
//                                     <td className="border p-3 font-medium">{user.user_id}</td>
//                                     <td className="border p-3">{user.total_opens}</td>
//                                     <td className="border p-3">{user.last_active}</td>
//                                     <td className={`border p-3 ${user.is_active ? "text-green-600" : "text-red-600"}`}>
//                                         {user.is_active ? "🟢 Yes" : "🔴 No"}
//                                     </td>
//                                     <td className={`border p-3 ${user.is_inquisitive ? "text-green-600" : "text-red-600"}`}>
//                                         {user.is_inquisitive ? "🟢 Yes" : "🔴 No"}
//                                     </td>
//                                     <td className="border p-3">
//                                         <button
//                                             onClick={() => toggleRow(user.user_id)}
//                                             className="text-blue-600 font-medium flex items-center"
//                                         >
//                                             {expandedRows[user.user_id] ? "▼ Hide" : "▶ View Visits"}
//                                         </button>
//                                     </td>
//                                 </tr>
//                                 {expandedRows[user.user_id] && (
//                                     <tr>
//                                         <td colSpan={6} className="border p-3 bg-gray-50">
//                                             {user.page_visits.length > 0 ? (
//                                                 <table className="w-full border-collapse border border-gray-300 mt-2">
//                                                     <thead className="bg-gray-200">
//                                                         <tr>
//                                                             <th className="border p-2 text-left font-semibold">Module</th>
//                                                             <th className="border p-2 text-left font-semibold">Category</th>
//                                                             <th className="border p-2 text-left font-semibold">Description</th>
//                                                             <th className="border p-2 text-left font-semibold">Visit Time</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {/* {user.page_visits.map((visit, i) => ( */}
//                                                         {user.page_visits
//                                                             .map((visit) => ({
//                                                                 ...visit,
//                                                                 visit_time: visit.visit_time?.toDate ? visit.visit_time.toDate() : new Date(visit.visit_time)
//                                                             })) // Convert visit_time to Date first
//                                                             .sort((a, b) => b.visit_time.getTime() - a.visit_time.getTime()) // Sort by timestamp (latest first)
//                                                             .map((visit, i) => (
//                                                                 <tr key={i} className="hover:bg-gray-100">
//                                                                     <td className="border p-2">{visit.page_name}</td>
//                                                                     <td className="border p-2">{visit.category}</td>
//                                                                     <td className="border p-2">{visit.description}</td>
//                                                                     <td className="border p-2">{formatTimestamp(visit.visit_time)}</td>
//                                                                 </tr>
//                                                             ))}
//                                                     </tbody>
//                                                 </table>
//                                             ) : (
//                                                 <span className="text-gray-500">No visits recorded</span>
//                                             )}
//                                         </td>

//                                     </tr>
//                                 )}
//                             </React.Fragment>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default AnalyticsScreen;




// // import React, { useState, useEffect } from "react";


// // import { collection, onSnapshot } from "firebase/firestore";
// // import db from "./Firebase"; // Firebase configuration

// // const AnalyticsScreen = () => {
// //     const [userStats, setUserStats] = useState([]);
// //     const [loading, setLoading] = useState(true);

// //     useEffect(() => {
// //         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
// //             let usersData = [];

// //             snapshot.forEach((userDoc) => {
// //                 let userId = userDoc.id;
// //                 let userData = userDoc.data();

// //                 usersData.push({
// //                     user_id: userId,
// //                     total_opens: userData.total_opens || 0,
// //                     total_duration: userData.total_duration || 0,
// //                     last_active: userData.last_active ? formatTimestamp(userData.last_active) : "N/A",
// //                     is_active: userData.is_active || false,
// //                     is_inquisitive: userData.is_inquisitive || false,
// //                     page_visits: Array.isArray(userData.page_visits) ? userData.page_visits : [],
// //                 });
// //             });

// //             setUserStats(usersData);
// //             setLoading(false);
// //         });

// //         return () => unsubscribe(); // Cleanup function to stop listening when component unmounts
// //     }, []);

// //     // ✅ Function to Convert Firestore Timestamp to Readable Date-Time
// //     const formatTimestamp = (timestamp) => {
// //         if (!timestamp) return "N/A";
// //         let date;

// //         // If Firestore Timestamp, convert using toDate()
// //         if (timestamp.toDate) {
// //             date = timestamp.toDate();
// //         } else {
// //             date = new Date(timestamp); // In case it's already a string/number timestamp
// //         }

// //         return date.toLocaleString(); // Convert to readable date-time format
// //     };

// //     return (
// //         <div className="container mt-4">
// //             <h3>User Analytics (Real-Time)</h3>
// //             {loading ? (
// //                 <p>Loading data...</p>
// //             ) : (
// //                 <div className="table-responsive">
// //                     <table className="table table-bordered">
// //                         <thead>
// //                             <tr>
// //                                 <th>User ID</th>
// //                                 <th>Total Opens</th>
// //                                 {/* <th>Total Duration (s)</th> */}
// //                                 <th>Last Active</th>
// //                                 <th>Active (45s+)</th>
// //                                 <th>Inquisitive (2+ Pages)</th>
// //                                 <th>Page Visits</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {userStats.map((user, index) => (
// //                                 <tr key={index}>
// //                                     <td>{user.user_id}</td>
// //                                     <td>{user.total_opens}</td>
// //                                     {/* <td>{user.total_duration}</td> */}
// //                                     <td>{user.last_active}</td>
// //                                     <td>{user.is_active ? "Yes" : "No"}</td>
// //                                     <td>{user.is_inquisitive ? "Yes" : "No"}</td>
// //                                     <td>
// //                                         {user.page_visits.length > 0 ? (
// //                                             <ul>
// //                                                 {user.page_visits.map((visit, i) => (
// //                                                     <li key={i}>
// //                                                         <strong>{visit.page_name || "Unknown Page"}</strong> - {formatTimestamp(visit.visit_time)}
// //                                                     </li>
// //                                                 ))}
// //                                             </ul>
// //                                         ) : (
// //                                             <span>No visits recorded</span>
// //                                         )}
// //                                     </td>
// //                                 </tr>
// //                             ))}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default AnalyticsScreen;


// // // import React, { useState, useEffect } from "react";


// // // import { collection, onSnapshot } from "firebase/firestore";
// // // import db from "./Firebase"; // Firebase configuration

// // // const AnalyticsScreen = () => {
// // //     const [userStats, setUserStats] = useState([]);
// // //     const [loading, setLoading] = useState(true);

// // //     useEffect(() => {
// // //         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
// // //             let usersData = [];

// // //             snapshot.forEach((userDoc) => {
// // //                 let userId = userDoc.id;
// // //                 let userData = userDoc.data();

// // //                 usersData.push({
// // //                     user_id: userId,
// // //                     total_opens: userData.total_opens || 0,
// // //                     total_duration: userData.total_duration || 0,
// // //                     last_active: userData.last_active || "N/A",
// // //                     is_active: userData.is_active || false,
// // //                     is_inquisitive: userData.is_inquisitive || false,
// // //                     page_visits: Array.isArray(userData.page_visits) ? userData.page_visits : [], // ✅ Ensure it's an array
// // //                 });
// // //             });

// // //             setUserStats(usersData);
// // //             setLoading(false);
// // //         });

// // //         return () => unsubscribe(); // Cleanup function to stop listening when component unmounts
// // //     }, []);

// // //     return (
// // //         <div className="container mt-4">
// // //             <h3>User Analytics (Real-Time)</h3>
// // //             {loading ? (
// // //                 <p>Loading data...</p>
// // //             ) : (
// // //                 <div className="table-responsive">
// // //                     <table className="table table-bordered">
// // //                         <thead>
// // //                             <tr>
// // //                                 <th>User ID</th>
// // //                                 <th>Total Opens</th>
// // //                                 <th>Total Duration (s)</th>
// // //                                 <th>Last Active</th>
// // //                                 <th>Active (45s+)</th>
// // //                                 <th>Inquisitive (2+ Pages)</th>
// // //                                 <th>Page Visits</th>
// // //                             </tr>
// // //                         </thead>
// // //                         <tbody>
// // //                             {userStats.map((user, index) => (
// // //                                 <tr key={index}>
// // //                                     <td>{user.user_id}</td>
// // //                                     <td>{user.total_opens}</td>
// // //                                     <td>{user.total_duration}</td>
// // //                                     <td>{new Date(user.last_active).toLocaleString()}</td>
// // //                                     <td>{user.is_active ? "Yes" : "No"}</td>
// // //                                     <td>{user.is_inquisitive ? "Yes" : "No"}</td>
// // //                                     <td>
// // //                                         {user.page_visits.length > 0 ? (
// // //                                             <ul>
// // //                                                 {user.page_visits.map((visit, i) => (
// // //                                                     <li key={i}>
// // //                                                         <strong>{visit.page_name || "Unknown Page"}</strong> - {visit.visit_time ? new Date(visit.visit_time).toLocaleString() : "N/A"}
// // //                                                     </li>
// // //                                                 ))}
// // //                                             </ul>
// // //                                         ) : (
// // //                                             <span>No visits recorded</span>
// // //                                         )}
// // //                                     </td>
// // //                                 </tr>
// // //                             ))}
// // //                         </tbody>
// // //                     </table>
// // //                 </div>
// // //             )}
// // //         </div>
// // //     );
// // // };

// // // export default AnalyticsScreen;
